// context/LanguageContext.tsx

"use client"; // Indica che il componente è lato client

import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
  //ReactNode,
} from 'react'

type Lang = 'en' | 'it'

// Tipo per definire il contesto della lingua
/*type LanguageContextType = {
    language: string;
    setLanguage: (lang: string) => void;
};*/
type LanguageContextType = {
    language: Lang;
    setLanguage: (lang: Lang) => void;
};

// Creazione del contesto
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
/*const LanguageContext = createContext<{
  language: Lang
  setLanguage: (lang: Lang) => void
} | null>(null)*/

// Provider che rileva la lingua e gestisce lo stato
/*export const LanguageProvider = ({ children }: { children: ReactNode }) => {
    const [language, setLanguage] = useState<string>("en"); // Lingua predefinita

    useEffect(() => {
        // Rileva la lingua del browser
        const browserLang = navigator.language.split("-")[0]; // Rimuove eventuali dettagli regionali (es. "it-IT" diventa "it") 'it', 'en', ecc.
        setLanguage(browserLang || "en"); // Fallback su "en"
        document.cookie = `lang=${language}; Path=/; Max-Age=31536000; SameSite=Lax`
    }, []);

    return (
        <LanguageContext.Provider value={{ language, setLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};*/

function readCookieLang(): Lang | null {
    if (typeof document === "undefined") return null
    const m = document.cookie.match(/(?:^|;\s*)lang=(en|it)(?:;|$)/)
    return (m?.[1] as Lang) ?? null
}

function writeCookieLang(lang: Lang) {
    document.cookie = `lang=${lang}; Path=/; Max-Age=31536000; SameSite=Lax`
}

export function LanguageProvider({
  initialLanguage = 'en',
  children,
}: {
  initialLanguage?: Lang
  children: React.ReactNode
}) {
  const [language, setLanguageState] = useState<Lang>(initialLanguage)

  const setLanguage = (lang: Lang) => {
    setLanguageState(lang)
    writeCookieLang(lang)
  }

  useEffect(() => {
    // Se esiste già cookie, allinea lo state al cookie (senza mismatch perché è dopo mount)
    const cookieLang = readCookieLang()
    if (cookieLang) {
        if (cookieLang !== language) setLanguageState(cookieLang)
        return
    }

    // Nessun cookie: facoltativamente imposta dal browser DOPO mount
    const browser = (navigator.language?.split('-')[0] as Lang) || 'en'
    const next = browser === 'it' ? 'it' : 'en'
    if (next !== language) {
        setLanguageState(next)
    }
    writeCookieLang(next)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const value = useMemo(() => ({ language, setLanguage }), [language])

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  )
}

// Custom Hook per utilizzare il contesto della lingua
export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};
